import { ChangeDetectionStrategy, Component, Input, OnInit, HostListener, ChangeDetectorRef } from '@angular/core';
import { BlockMargin } from '@service/article/article.service';
import { MarginService } from '../margin.service';

interface CollectionProductsInterface
{
  type: string,
  name: string,
  header: string,
  headingLink: string,
  headingLinkDescription: string,
  sliderLink: string,
  pagination: boolean,
  navigation: string,
  fullScreen: boolean
}

@Component({
    selector: 'app-collection-products',
    templateUrl: './collection-products.component.html',
    styleUrls: ['./collection-products.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CollectionProductsComponent implements OnInit
{
  @Input() section: CollectionProductsInterface;
  @Input() type: string;
  @Input() margin: BlockMargin;

  constructor(public marginService: MarginService, public changeDet: ChangeDetectorRef) { }

  ngOnInit(): void
  {
  }

  @HostListener('window:resize', ['$event'])
  public onWindowResize($event): void
  {
    this.changeDet.detectChanges();

  }
}
